import { app } from '../../bootstrap/core';
import { bankInfoState } from './bankInfo.state';
import { bankInfoComponent } from './bankInfo.component';
import SearchBankTemplate from './partials/search.tpl.html';

app.config(bankInfoState);
app.constant('SearchBankTemplate', SearchBankTemplate);
app.component(bankInfoComponent.name, bankInfoComponent);
